import { useLoaderData, useNavigate } from "react-router-dom";
import api from "../storage/api";
import { useState } from "react";
import styles from "./Home.module.css";

const HomePage = () => {
  const data = useLoaderData();
  const [active, setActive] = useState(0);
  const navigate = useNavigate();
  document.body.classList.add(styles.body);
  
  return (
    <div className={styles.window}>
      <div className={styles.wrapper}>
        <div className={styles.modal}>
          <h1 className={styles.title}>Выбор сервера</h1>
          <p className={styles.description}>
            Выбери сервер, на который желаешь приобрести донат
          </p>
          <div className={styles.serversWrapper}>
            {data.length > 0 &&
              data.map((item, index) => (
                <button
                  className={
                    active === index
                      ? `${styles.server} ${styles.active}`
                      : styles.server
                  }
                  type="button"
                  key={index}
                  onClick={() => setActive(index)}
                >
                  <img
                    className={styles.image}
                    alt={item.name}
                    src={`${api.apiImages}${item.image}`}
                  />
                </button>
              ))}
          </div>
          <button type="button" className="modal-btn" onClick={() => navigate(`/${data[active].slug}`)}>
            Перейти к странице сервера
          </button>
          <span className={styles.chosenServer}>
            Вы выбрали сервер <b className={styles.purple}>{data[active].name}</b>
          </span>
        </div>
      </div>
    </div>
  );
};

export default HomePage;

export async function loader() {
  const response = await fetch(api.apiPath + "&path=servers");

  if (!response.ok) {
    alert("Произошла ошибка при загрузке данных...");
  } else {
    return response.json();
  }
}
